import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';

import config from '../../config';
import titleImgLogo from '../../assets/pictures/mainTitleImg.svg';

import css from './LandingPage.css';
import { Search } from '../../components';

const locale = config.locale;
const imgTitlePosition = classNames(css.mainTitleImg, {
  [css.mainTitleImgES]: locale === 'es',
  [css.mainTitleImgDE]: locale === 'de',
  [css.mainTitleImgIT]: locale === 'it',
  [css.mainTitleImgUS]: locale === 'en',
});

const SectionMain = (props) => {
  const { isMobile, intl } = props;
  const { hasInsurance, insuranceLogo } = config.custom;

  const titleImg = (
    <div className={css.mainTitleImgContainer}>
      <img className={imgTitlePosition} src={titleImgLogo} alt="smile" />
    </div>
  );
  const title = <FormattedMessage id="LandingPage.mainTitle" values={{ img: titleImg }} />;
  const subtitle = intl.formatMessage({ id: 'LandingPage.mainSubtitle' });

  return (
    <div className={css.sectionMain}>
      <div className={css.mainContainer}>
        <div className={css.mainHeroContainer}>
          <div className={css.mainTitleContainer}>
            <span className={css.mainTitle}>{title}</span>
            <h1 className={css.mainSubtitle}>{subtitle}</h1>
            <Search currentPage={'LandingPage'} />
          </div>
          <div className={css.mainBackground}>
            <div className={css.mainWomanImg} />
            <div className={css.mainManImg} />
            <div className={css.mainChildImg} />
          </div>
        </div>
        {hasInsurance ? (
          <div className={css.mainInsurance}>
          </div>
        ) : null}
      </div>

      <div className={css.mainContainerDesktop}>
        <div className={css.mainLeftContainer}>
          <div className={css.mainHeroContainerDesktop}>
            <div className={css.mainTitleContainer}>
              <span className={css.mainTitle}>{title}</span>
              <h1 className={css.mainSubtitle}>{subtitle}</h1>
            </div>
          </div>
          {hasInsurance ? (
            <div className={css.mainInsurance}>
            </div>
          ) : null}
        </div>
        <div className={css.mainRightContainer}>
          <div className={css.mainWomanImg} />
          <div className={css.mainManImg} />
          <div className={css.mainChildImg} />
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SectionMain);
